import Vue from 'vue'
import locales from '@/assets/js/$/i18n/locales'

export default {
  namespaced: true,
  state: {
    i18n: {},
    menuActive: false,
    modalOpen: false,
    specialHeader: false
  },
  getters: {
    specialHeader: state => state.specialHeader,
    getLocale: state => state.i18n.locale,
    getLooseLocale: state => state.i18n.locale.toLowerCase().substr(0, 2),
    menuStatus: state => state.menuActive,
    modalStatus: state => state.modalOpen
  },
  mutations: {
    SET_SPECIAL_HEADER(state, payload = false) {
      state.specialHeader = payload === true
    },
    setI18n(state, i18n = {}) {
      state.i18n = i18n
    },
    setLocale(state, locale = '') {
      let AVAILABLE = state.i18n.AVAILABLE || []

      if (AVAILABLE.exact.includes(locale)) {
        Vue.set(state.i18n, 'locale', locale)
        localStorage.setItem('locale', locale)
      } else if (AVAILABLE.loose.includes(locale)) {
        Vue.set(
          state.i18n,
          'locale',
          AVAILABLE.exact[AVAILABLE.loose.findIndex(l => l === locale)]
        )
        localStorage.setItem(
          'locale',
          AVAILABLE.exact[AVAILABLE.loose.findIndex(l => l === locale)]
        )
      } else {
        console.warn(
          `There is no translation definition available for "${locale}"!`
        )
      }
    },
    setMenuStatus(state, payload) {
      state.menuActive = payload === true
    },
    setModalStatus(state, payload) {
      state.modalOpen = payload === true
    }
  },
  actions: {
    setSpecialHeader({ commit }, value) {
      commit('SET_SPECIAL_HEADER', value)
    }
  }
}

// export const state = {
//   currentLang: 'de',
// }

// export const mutations = {
//   SET_CURRENT_LANGUAGE(state, value) {
//     state.currentLang = value
//   },
// }

// export const actions = {
//   setCurrentLang({ commit }, value) {
//     commit('SET_CURRENT_LANGUAGE', value)
//   },
// }
